
//=================================================================================================
import React, { useState, useEffect } from "react";
import {
  FaChartPie,
  FaEnvelope,
  FaUsers,
  FaProjectDiagram,
  FaRocket,
  FaLaptopHouse,
  FaGlobe,
  FaBullhorn,
  FaHandshake,
  FaBoxes,
  FaFileContract,
  FaCloud,
  FaComments,
  FaBalanceScale,
  FaUserCheck,
  FaArrowLeft,
  FaSearch,
  FaCog,
  FaBell,
  FaTasks 
} from "react-icons/fa";
import "./App.css";
import logo from './Final-logo-SBS.png'; // Import your logo image

const CirclePage = () => {
  const [activeFeature, setActiveFeature] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false); // Set to false to disable animation
  const [currentPage, setCurrentPage] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  // Define URL mappings for each feature
  // const featureUrls = {
  //   "Analytics": "http://82.25.108.64:86/",
  //   "Sales": "http://145.79.0.94:86/login",
  //   "Marketing": "https://tallytouch.com/",
  //   "Website": "https://www.kotharimensstudio.com/",
  //   "Visitor Tracking": "https://example.com/visitor-tracking",
  //   "Accounting": "https://example.com/accounting",
  //   "Contracts": "https://example.com/contracts",
  //   "Social Media": "https://example.com/social-media",
  //   "Online Storage": "https://example.com/online-storage",
  //   "Online Office": "https://example.com/online-office",
  //   "Helpdesk": "https://example.com/helpdesk",
  //   "Email": "https://example.com/email",
  //   "Team Chat": "https://example.com/team-chat",
  //   "Team Projects": "https://example.com/team-projects",
  //   "Automation": "https://example.com/automation",
  //   "Remote Work": "https://example.com/remote-work"
  // };

   const featureUrls = {
   "CRM": "https://crm.sbsgroups.co.in/",
   // "CRM": "http://localhost:3000/",
    "Inventory": "https://inventory.sbsgroups.co.in/",
    "Attendance": "https://attendence.sbsgroups.co.in/admin-login/",
    "Website": "https://test.sbsgroups.co.in/",
    "Employee Management": "https://employeemanagementapp.sbsgroups.co.in/"
  };

  // const features = [
  //   { name: "Website", icon: <FaGlobe />, color: "#3B82F6", category: "Marketing" },
  //   { name: "Visitor Tracking", icon: <FaUserCheck />, color: "#10B981", category: "Analytics" },
  //   { name: "Sales", icon: <FaHandshake />, color: "#F59E0B", category: "Business" },
  //   { name: "Accounting", icon: <FaBalanceScale />, color: "#EF4444", category: "Finance" },
  //   { name: "Contracts", icon: <FaFileContract />, color: "#8B5CF6", category: "Legal" },
  //   { name: "Marketing", icon: <FaBullhorn />, color: "#EC4899", category: "Marketing" },
  //   { name: "Social Media", icon: <FaUsers />, color: "#06B6D4", category: "Marketing" },
  //   { name: "Online Storage", icon: <FaCloud />, color: "#6366F1", category: "Productivity" },
  //   { name: "Analytics", icon: <FaChartPie />, color: "#F97316", category: "Analytics" },
  //   { name: "Online Office", icon: <FaLaptopHouse />, color: "#14B8A6", category: "Productivity" },
  //   { name: "Helpdesk", icon: <FaUserCheck />, color: "#84CC16", category: "Support" },
  //   { name: "Email", icon: <FaEnvelope />, color: "#F43F5E", category: "Communication" },
  //   { name: "Team Chat", icon: <FaComments />, color: "#0EA5E9", category: "Communication" },
  //   { name: "Team Projects", icon: <FaProjectDiagram />, color: "#A855F7", category: "Productivity" },
  //   { name: "Automation", icon: <FaRocket />, color: "#EAB308", category: "Productivity" },
  //   { name: "Remote Work", icon: <FaLaptopHouse />, color: "#64748B", category: "Productivity" },
  // ];


  const features = [
  { name: "CRM", icon: <FaHandshake />, color: "#F59E0B", category: "Business" },
  { name: "Inventory", icon: <FaBoxes />, color: "#6366F1", category: "Productivity" },
  { name: "Attendance", icon: <FaUserCheck />, color: "#84CC16", category: "Support" },
  { name: "Website", icon: <FaGlobe />, color: "#3B82F6", category: "Marketing" },
  { name: "Email Service", icon: <FaEnvelope />, color: "#F43F5E", category: "Communication" },
  { name: "Employee Management", icon: <FaTasks  />, color: "#A855F7", category: "Productivity" },
  { name: "Accounting", icon: <FaBalanceScale />, color: "#EF4444", category: "Finance" },
];

  const categories = [...new Set(features.map(feature => feature.category))];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  const filteredFeatures = features.filter(feature => 
    feature.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    feature.category.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleFeatureClick = (featureName) => {
    // Check if the feature has a URL mapping
    if (featureUrls[featureName]) {
      // Redirect to the external URL
      window.open(featureUrls[featureName], '_blank');
    } else {
      // For features without a URL mapping, show the detail page
      setCurrentPage(featureName);
    }
  };

  const handleBackClick = () => {
    setCurrentPage(null);
  };

  if (currentPage) {
    const feature = features.find(f => f.name === currentPage);
    return (
      <div className="application-page">
        <header className="app-header fixed-header">
          <div className="header-content">
            <button className="back-button" onClick={handleBackClick}>
              <FaArrowLeft /> Back to Applications
            </button>
            <div className="header-actions">
              <div className="search-box">
                <FaSearch />
                <input type="text" placeholder="Search..." />
              </div>
              <button className="icon-button">
                <FaBell />
              </button>
              <button className="icon-button">
                <FaCog />
              </button>
              <div className="user-avatar">
                <img src="https://i.pravatar.cc/40" alt="User" />
              </div>
            </div>
          </div>
        </header>
        
        <div className="app-content" style={{ paddingTop: '70px' }}>
          <div className="app-hero" style={{ backgroundColor: `${feature.color}08` }}>
            <div className="app-icon-large" style={{ color: feature.color, backgroundColor: `${feature.color}15` }}>
              {feature.icon}
            </div>
            <div className="app-info">
              <div className="app-category" style={{ backgroundColor: `${feature.color}15`, color: feature.color }}>
                {feature.category}
              </div>
              <h1>{feature.name}</h1>
              <p>Streamline your {feature.name.toLowerCase()} processes with our integrated solution</p>
            </div>
          </div>
          
          <div className="app-dashboard">
            <div className="dashboard-card">
              <h3>Overview</h3>
              <div className="stats-grid">
                <div className="stat-item">
                  <div className="stat-value">245</div>
                  <div className="stat-label">Active Users</div>
                </div>
                <div className="stat-item">
                  <div className="stat-value">98%</div>
                  <div className="stat-label">Uptime</div>
                </div>
                <div className="stat-item">
                  <div className="stat-value">12</div>
                  <div className="stat-label">New This Week</div>
                </div>
              </div>
            </div>
            
            <div className="dashboard-card">
              <h3>Quick Actions</h3>
              <div className="action-buttons">
                <button className="action-btn" style={{ backgroundColor: feature.color }}>
                  Create New
                </button>
                <button className="action-btn outline" style={{ borderColor: feature.color, color: feature.color }}>
                  Generate Report
                </button>
                <button className="action-btn outline" style={{ borderColor: feature.color, color: feature.color }}>
                  Share
                </button>
              </div>
            </div>
            
            <div className="dashboard-card">
              <h3>Recent Activity</h3>
              <ul className="activity-list">
                <li>User registration completed</li>
                <li>New data imported</li>
                <li>System update installed</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="circle-page-container">
      <div className="content-wrapper" style={{ paddingTop: '30px' }}>
        <div className="page-header">
          <h1>Business Applications</h1>
          <p>Access all your integrated tools in one place</p>
        </div>
        
        <div className="circle-container-wrapper">
          <div className="center-circle">
            <div className="center-content">
              {/* Center logo only */}
              <div className="center-logo">
                <img  style={{width: '160px', height: '150px'}}
                //  src="https://sp-ao.shortpixel.ai/client/q_lossless,ret_img/https://www.iiiqbets.com/wp-content/uploads/2021/04/png-1.png" 
                 src={logo}
                alt="Business Platform Logo" 
                />
              </div>
              <div className="pulse-ring"></div>
              <div className="pulse-ring delay-1"></div>
              <div className="pulse-ring delay-2"></div>
            </div>
          </div>

          <div className="features-circle">
            {filteredFeatures.map((feature, index) => {
              // Calculate fixed positions around the circle (no animation)
              const angle = (index / filteredFeatures.length) * 360;
              const radius = 200; // Fixed radius
              const x = radius * Math.cos((angle * Math.PI) / 180);
              const y = radius * Math.sin((angle * Math.PI) / 180);
              
              return (
                <div
                  key={index}
                  className="feature-item"
                  style={{ 
                    transform: `translate(${x}px, ${y}px)`,
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    margin: '-24px 0 0 -24px' // Center the item
                  }}
                  onMouseEnter={() => setActiveFeature(index)}
                  onMouseLeave={() => setActiveFeature(null)}
                  onClick={() => handleFeatureClick(feature.name)}
                >
                  <div 
                    className="icon-wrapper"
                    style={{ backgroundColor: feature.color }}
                  >
                    {feature.icon}
                  </div>
                  <div className="feature-tooltip">
                    <span>{feature.name}</span>
                    <div className="feature-category">{feature.category}</div>
                    <div className="click-hint">
                      {featureUrls[feature.name] ? "Click to open" : "Click to explore"}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        
        <div className="applications-grid">
          {filteredFeatures.map((feature, index) => (
            <div 
              key={index} 
              className="app-card"
              style={{ borderLeft: `4px solid ${feature.color}` }}
              onClick={() => handleFeatureClick(feature.name)}
            >
              <div className="app-icon" style={{ color: feature.color, backgroundColor: `${feature.color}15` }}>
                {feature.icon}
              </div>
              <div className="app-info">
                <div className="app-name">{feature.name}</div>
                <div className="app-category">{feature.category}</div>
              </div>
              <div className="app-arrow">→</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CirclePage;